import { render, staticRenderFns } from "./PatientServicesModal.vue?vue&type=template&id=395554da&scoped=true"
import script from "./PatientServicesModal.vue?vue&type=script&lang=js"
export * from "./PatientServicesModal.vue?vue&type=script&lang=js"
import style0 from "./PatientServicesModal.vue?vue&type=style&index=0&id=395554da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395554da",
  null
  
)

export default component.exports